var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-production-task-list',{staticClass:"pt-production-task-list__page"})}
var staticRenderFns = []

export { render, staticRenderFns }